import "../css/main.css";
import ImageSlider from "./ImageSlider.js";
import Form from "./Form.js";
import consts from "../consts.js";

function Main({ language }) {
  const headerText =
    language === consts.ENGLISH
      ? consts.HeaderText_English
      : consts.HeaderText_Espanol;

  return (
    <div className="Main">
      <div className="image">
        <ImageSlider />
      </div>
      <div className="header">{headerText}</div>
      <div className="form">
        <Form language={language} />
      </div>
    </div>
  );
}

export default Main;
